export default __webpack_public_path__ + "static/media/Shrink.d224fd00.svg";